// ===== Styles =====
import {makeStyles} from "@material-ui/core/styles";
import {Colors} from "../../styles/Colors";
import {TabInterface} from "./Tabs.utils";
import {
    ServiceFeature,
    ServiceFeatureAtributes,
    ServiceFeatureName,
} from "../../store/types/ServiceFeature";
import {YesNo} from "../../store/types/CallScreening";

export const useStyles = makeStyles(() => ({
    root: {
        maxWidth: 1040,
        paddingLeft: 16,
    },
    loader: {
        height: 500,
        display: 'flex',
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
    },
    swicher: {
        marginBottom: 2,
        paddingTop: 22,
        height: 'auto',
        color: Colors.Gray7,
    },
    rowContainer: {
        flex: 1,
        display: 'flex',
        paddingTop: 16,
        paddingBottom: 24,
        alignItems: 'flex-start',
        '& > :first-child': {
            marginRight: 32,
        },
        '&:last-of-type': {
            paddingBottom: 0,
        },
    },
    input: {
        width: 320
    },
    buttonStyle: {}
}));

// ===== Types and Interfaces =====
export interface AiTabInterface extends TabInterface {
    sessionToken?: string | null
}

// ===== Pure helpers =====
export const getSipStaticContactService = (
    features?: ServiceFeature[],
): ServiceFeature | undefined =>
    features?.find((el) => el.name === ServiceFeatureName.SipStaticContact);

export const isSipStaticContactOn = (features?: ServiceFeature[]): boolean =>
    getSipStaticContactService(features)?.effective_flag_value === YesNo.Yes;

export const buildSipContactFromService = (service: ServiceFeature): string | null => {
    const findAttr = (n: string) =>
        service.attributes.find((a: ServiceFeatureAtributes) => a.name === n);
    const host = findAttr('host');
    const port = findAttr('port');
    const user = findAttr('user');
    if (!user?.values[0] || !host?.values[0] || !port?.values[0]) return null;
    return `${user.values[0]}@${host.values[0]}:${port.values[0]}`;
};
